import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { PageModel } from "@app/models/page.model";
import { SupplyResponse } from "@app/ui_models/web-response";
import { env } from "@environments/environment";
import { LogAction } from "@app/ui_models/model-dto";

@Injectable({ providedIn: "root" })
export class ActionsController {

  public constructor(httpService: HttpClient) {
    this.httpService = httpService;
  }

  httpService: HttpClient;

  public searchActions(params: HttpParams): Observable<PageModel<LogAction>>  {
    return this.httpService.get(env.logisticsServiceBackend + "/logistics/v1/actions/all/filtered", { params, responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

  public searchLogActions(): Observable<LogAction[]>  {
    return this.httpService.get(env.logisticsServiceBackend + "/logistics/v1/actions/all", { responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }

  public downloadActionsExcel(params: HttpParams): Observable<Blob> {
    return this.httpService.get(env.logisticsServiceBackend + "/logistics/v1/actions/export", {
      params,
      responseType: "blob",
    });
  }

  public getAllFilterOptions(): Observable<any>  {
    const params: HttpParams = new HttpParams();
    return this.httpService.get(env.logisticsServiceBackend + "/logistics/v1/actions/filter/options", { params, responseType: "text" }).pipe(map(res => (res ? JSON.parse(res) : undefined)));
  }
}
